import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
    NgbModule,
    NgbDropdownModule,
    NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { SharedModule } from '../core/shared/shared.module';
import { LayoutRoutingModule } from './layout-routing.module';
import { ShellComponent } from './shell/shell.component';
import { FilePreviewComponent } from '../features/file-preview/file-preview.component';
import { FilePickerComponent } from '../features/file-picker/file-picker.component';
import { XSheetComponent } from '../features/x-sheet/x-sheet.component';
import { JsonViewComponent } from '../features/json-view/json-view.component';
import { SchemaBuilderComponent } from '../features/schema-builder/schema-builder.component';
import { AgGridViewComponent } from '../features/ag-grid-view/ag-grid-view.component';
import { EmptyStateComponent } from '../features/empty-state/empty-state.component';
import { FileDragNDropDirective } from '../core/directives/drag-n-drop.directives';
import { SpreadSheetSourceComponent } from '../pages/spreadsheetsource/spreadsheetsource.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { WorkspaceManagerComponent } from './sidebar/workspace-manager/workspace-manager.component';
import { SidebarHeaderComponent } from './sidebar/sidebar-header/sidebar-header.component';
import { AccountMenuComponent } from './sidebar/account-menu/account-menu.component';
import { ApiAccessCardComponent } from './sidebar/api-access-card/api-access-card.component';
import { ApiKeysModalComponent } from '../features/api-keys-modal/api-keys-modal.component';
import { JobManagementComponent } from '../features/job-management/job-management.component';
import { IntegrationsComponent } from '../features/integrations/integrations.component';
import { PagesModule } from '../pages/pages.module';
import { DocumentQaInfoComponent } from './shell/document-qa-info/document-qa-info.component';

@NgModule({
    declarations: [
        WorkspaceManagerComponent,
        LayoutComponent,
        HeaderComponent,
        ShellComponent,
        FileDragNDropDirective,
        SpreadSheetSourceComponent,
        SidebarHeaderComponent,
        AccountMenuComponent,
        ApiAccessCardComponent,
        SidebarComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LayoutRoutingModule,
        NgbModule,
        HttpClientModule,
        RouterModule,
        NgbDropdownModule,
        NgbNavModule,
        DragDropModule,
        SharedModule,
        FilePreviewComponent,
        FilePickerComponent,
        XSheetComponent,
        JsonViewComponent,
        SchemaBuilderComponent,
        AgGridViewComponent,
        DocumentQaInfoComponent,
        EmptyStateComponent,
        ApiKeysModalComponent,
        JobManagementComponent,
        IntegrationsComponent,
        PagesModule,
    ],
    exports: [FileDragNDropDirective],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule {}
